<template>
  <div>
    <div class="ag__dropdown" :class="{ active: menuIsActive }">
      <div
        class="ag__dropdown__item ag__dropdown__item--active"
        @click="setActiveItem(null, true)"
      >
        <span class="ag__dropdown__item__text" v-if="text">{{ text }}</span>
        <span class="ag__dropdown__item__text" v-else>{{
          activeItem.label
        }}</span>
        <span class="ag-icon ag-icon_greyRightArrow"></span>
      </div>
      <div class="ag__dropdown__menu">
        <div
          class="ag__dropdown__item"
          v-for="(item, index) in options"
          :key="index"
          @click="setActiveItem(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    text: {
      type: String,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeItem: null,
      menuIsActive: false,
    };
  },
  methods: {
    setActiveItem: function (data, selector) {
      const jQuery = window.jQuery;
      if (!selector) {
        this.activeItem = data;
        this.menuIsActive = false;
      } else {
        jQuery('.ag__dropdown').removeClass('active');
        setTimeout(() => {
          this.menuIsActive = !this.menuIsActive;
        }, 5);
      }
      if (data) {
        this.$emit("onChangeDropdown", data);
        this.menuIsActive = false;
      }
    },
    setValue(data) {
      this.activeItem = data;
    },
  },
  created() {
    this.activeItem = this.value;
  },
};
</script>
